import { FormUnit } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { StationsAdvancedFilterFieldFormik } from '../../../../../../../../../../components/stations/advanced-filter';
import { useStationsGroups } from '../../../../../../../../../../core/stations/hooks/useStationsGroupsQuery';
import { useStationsWithAudit } from '../../../../../../../../hooks/useStationsWithAudit';

export const GipStationsField_v2 = () => {
  const { $t } = useIntl();
  const stations = useStationsWithAudit();
  const stationsGroups = useStationsGroups();

  return (
    <Box mb={2}>
      <FormUnit
        label={$t({
          id: 'audit.gipReport.form.stations',
          defaultMessage: 'Emisoras',
        })}
      >
        <StationsAdvancedFilterFieldFormik
          name="stationsFilter"
          label={''}
          placeholder={$t({
            id: 'common.allStations',
            defaultMessage: 'Todas las estaciones',
          })}
          stations={stations}
          stationGroups={stationsGroups}
        />
      </FormUnit>
    </Box>
  );
};
